import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PreloadAllModules } from '@angular/router';
import { AppframeComponent } from './com/appframe/appframe.component';

const routes: Routes = [
  { path: 'homescreen', loadChildren: () => import('./pages/homescreen/homescreen.module').then(m => m.HomescreenModule) ,
   },
   { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule) ,
  },
  { path: '',   redirectTo: '/homescreen', pathMatch: 'full' }, // redirect to `first-component`
  { path: '**',   redirectTo: '/homescreen', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
